import React from 'react';
import { DialogTitle } from '@mui/material';

export const StyledDialogTitle: React.FC<{ children: React.ReactNode }> = (
    props
) => {
    return (
        <DialogTitle
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: '1px solid #ececec',
            }}
        >
            {props.children}
        </DialogTitle>
    );
};
